import script from "./SectionMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionMedia.vue?vue&type=script&setup=true&lang=js"

import "./SectionMedia.vue?vue&type=style&index=0&id=5014409a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5014409a"]])

export default __exports__